import { SubSink } from 'subsink';
import { Observable } from 'rxjs';
import {
  Component,
  Output,
  EventEmitter,
  Input,
  OnDestroy,
} from '@angular/core';

import { CouponCodeService } from './../../services/coupon-code.service';

enum PageState {
  INIT,
  COUPON_CODE_APPLIED,
  COUPON_CODE_INVALID,
}

@Component({
  selector: 'monorepo-coupon-code',
  templateUrl: './coupon-code.component.html',
  styleUrls: ['./coupon-code.component.scss'],
})
export class CouponCodeComponent implements OnDestroy {
  private subs = new SubSink();
  @Input()
  buttonColor: string = '';
  @Output()
  discountApplied: EventEmitter<number> = new EventEmitter<number>();

  pageStateEnum: typeof PageState = PageState;
  pageState: PageState = this.pageStateEnum.INIT;
  isDiscountApplied: boolean = false;
  discountValue: string;

  constructor(private couponCodeService: CouponCodeService) {}

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  public applyDiscountCode(discountCode: string): void {
    if (!discountCode) {
      return;
    }
    this.subs.sink = this.getDiscountValue(discountCode).subscribe({
      next: (discountValue: any): void => {
        if (discountValue) {
          this.discountValue = discountValue.value;
          this.isDiscountApplied = true;
          this.pageState = this.pageStateEnum.COUPON_CODE_APPLIED;
          this.discountApplied.emit(discountValue.value);
        } else {
          this.pageState = this.pageStateEnum.COUPON_CODE_INVALID;
        }
      },
    });
  }

  private getDiscountValue(discountCode: string): Observable<number> {
    return this.couponCodeService.getDiscountValue(discountCode);
  }

  public hideInvalidMessage(): void {
    this.pageState = this.pageStateEnum.INIT;
  }
}
